import styled from 'styled-components';
import { Grid, Button } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles({
  dialog: {
    ' & .MuiDialog-paperWidthSm': {
      maxWidth: '559px',
      maxHeight: '350px',
    },
  },
  areaSize: {
    '& textarea': {
      minHeight: '200px',
      maxHeight: '500px',
      width: '100% !important ',
    },
  },
});

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ActionsButtons = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  button {
    color: #564872;
    border: 1px solid #564872;
    display: flex;
    font-size: 14px;
    font-weight: bold;
    width: 89px;
    height: 26px;
    text-transform: none;
    min-width: 89px;
  }
`;

export const HistoricoGrid = styled(Grid)`
  margin-top: 34px;
  padding-left: 12px;
  border-radius: 7px;
  border: 1px solid #707070;
`;

export const ButtonNovo = styled(Button)`
  margin-right: 9px;
  font-size: 14px;
  color: #564872;

  :disabled {
    color: #c4c4c4;
  }

  & .MuiButton-label span {
    margin-left: 8px;
  }
`;
